import type { ReactNode } from 'react'

interface Props {
  title?: string
  description?: string
  action?: ReactNode
  children: ReactNode
  className?: string
}

export default function Section({ title, description, action, children, className = '' }: Props) {
  return (
    <section className={['rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]', className].join(' ')}>
      {(title || action) && (
        <header className="flex items-start justify-between px-4 py-3 border-b border-[var(--color-border)]">
          <div>
            {title && <h3 className="text-sm font-semibold text-[var(--color-text)]">{title}</h3>}
            {description && <p className="text-xs text-[var(--color-text-muted)] mt-0.5">{description}</p>}
          </div>
          {action}
        </header>
      )}
      <div className="p-4">{children}</div>
    </section>
  )
}
